import * as React from 'react'
import { FormattedMessage } from 'react-intl'
import { ICompanyProps } from '../../dooerPreOffer'
import styles from './companyCard.module.scss'

export default function CompanyCard({ company }: { company?: ICompanyProps }) {
  return (
    <div className={styles.root}>
      {company ? (
        <>
          <h3>{company.name}</h3>
          <p>
            {company.organizationNumber} {company.city}
          </p>
        </>
      ) : (
        <FormattedMessage defaultMessage="Hittade inget företag" id="signup-v3.components.company-card.placeholder" />
      )}
    </div>
  )
}
